export const CC_API_TAGS = {
    Tenant: 'Tenant',
    TenantSettings: 'TenantSettings',
    UserProfile: 'UserProfile',
    RuleAnalytics: 'RuleAnalytics',
    Rule: 'Rule',
    RuleList: 'RuleList',
    RuleFolder: 'RuleFolder',
    RuleFolderList: 'RuleFolderList',
    Redirect: 'Redirect',
    RedirectList: 'RedirectList',
    Template: 'Template',
    TemplateList: 'TemplateList',
    ImageList: 'ImageList',
    Tag: 'Tag',
    TagList: 'TagList',
    PreviewWrapper: 'PreviewWrapper',
    PreviewWrapperList: 'PreviewWrapperList',
    FilterSet: 'FilterSet',
    FilterSetList: 'FilterSetList',
    Zone: 'Zone',
    ZoneList: 'ZoneList',
    Site: 'Site',
    SiteList: 'SiteList',
    SiteShortList: 'SiteShortList',
    BiasingStrategy: 'BiasingStrategy',
    BiasingStrategyList: 'BiasingStrategyList',
    DynamicNavigation: 'DynamicNavigation',
    DynamicNavigationList: 'DynamicNavigationList',
    LinguisticControl: 'LinguisticControl',
    LinguisticControlList: 'LinguisticControlList',
    Collection: 'Collection',
    CollectionList: 'CollectionList',
    CollectionImageMetaData: 'CollectionImageMetaData',
    ReleaseNotes: 'ReleaseNotes',
    AnalyticsFolder: 'AnalyticsFolder',
    RecsModel: 'RecsModel',
    RecsModelList: 'RecsModelList',
    AttributeList: 'AttributeList',
    AttributeShortList: 'AttributeShortList',
    AttributeCount: 'AttributeCount',
    ActionableInsight: 'ActionableInsight',
    AuditEventList: 'AuditEventList',
    ProductRecommendation: 'ProductRecommendation',
    ProductRecommendationList: 'ProductRecommendationList',
    ProductRecommendationModelTypeList: 'ProductRecommendationModelTypeList',
    ExperimentStatistics: 'ExperimentStatistics',
    PermissionRole: 'PermissionRole',
    AdhocMessage: 'AdhocMessage',
    SeoKeywordList: 'SeoKeywordList',
    ProductAnalytics: 'ProductAnalytics',
    SeoDashboardAnalytics: 'SeoDashboardAnalytics',
    User: 'User',
    UserList: 'UserList',
    IdentityUser: 'IdentityUser',
    IdentityUserList: 'IdentityUserList',
    IdentityUserSettings: 'IdentityUserSettings',
    OrganizationConnections: 'OrganizationConnections',
    OrganizationWebApp: 'OrganizationWebApp',
};
export const CC_API_TAG_LIST = Object.values(CC_API_TAGS);
export const CATEGORIES_API_TAGS = {
    MegaMenus: 'MegaMenus',
    MegaMenuCategories: 'MegaMenuCategories',
    CustomCategory: 'CustomCategory',
};
export const CATEGORIES_API_TAG_LIST = Object.values(CATEGORIES_API_TAGS);
